export default (objects: string): string => `
-- THESE ARE ALL OF THE NODES/OBJECTS (pages, elements, tracking links, nodes, etc.) IN THE CURRENT FUNNEL --
${objects}
`;